/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import { get } from 'lodash'
import { path } from 'ramda'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { message } from 'antd'
import { config } from '../../../../config/Structure'
import CrudForm from '../../../Form'
import { connect } from 'react-redux'
import { uploadImages } from '../../../../config/Client/actions/Upload'
import queryString from 'query-string'

const EditBrandForm = ({ dispatch }) => {
  const { brands } = config
  const { id } = useParams()
  const history = useHistory()
  const location = useLocation()
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const query = queryString.parse(location.search)

  useEffect(() => {
    setLoading(true)
    dispatch(
      config.brands.edit.get({
        query: { _id: id },
        onSuccess: onFetchSuccess,
        onFailure: onFetchFailure,
      }),
    )
  }, []) // eslint-disable-line

  const onSubmit = (values) => {
    setSubmitting(true)
    dispatch(uploadImages({
      values,
      imageArray: values.images,
      moduleName: 'brands',
      _id: id,
      onSuccess: onUploadSuccess,
      onFailure,
    }))
  }

  const onUploadSuccess = (imageLinkArray, values) => {
    values.images = imageLinkArray
    dispatch(brands.edit.update({ body: { ...values, _id: id }, onSuccess, onFailure }))
  }

  const onSuccess = () => {
    setSubmitting(false)
    message.success('تم التعديل بنجاح')
    history.push(`/brands${location.search}`)
  }

  const onFailure = (error) => {
    setSubmitting(false)
    message.error('حدث خطأ')
  }

  const onFetchSuccess = (records) => {
    setLoading(false)
    if (query['company'] && path(['company', '_id'], records.data[Object.keys(records.data)[0]]) !== query['company']) {
      return history.push('/companies')
    }
    setData(records.data[Object.keys(records.data)[0]])
  }

  const onFetchFailure = (error) => {
    setLoading(false)
    message.error('حدث خطأ')
  }
  
  return (
    <CrudForm
      title='تعديل الماركة'
      loading={loading}
      fields={config.brands.edit.fields}
      onSubmit={onSubmit}
      buttonText='تعديل'
      initialValues={data}
      submitting={submitting}
    />
  )
}

const mapStateToProps = (state) => ({
  state,
})

export default connect(mapStateToProps)(EditBrandForm)
